import SlideFrame from './SlideFrame';

interface Props {
  title: string; sub: string; msg: string;
  col1_t: string; col2_t: string; col3_t: string;
  col1: string[]; col2: string[]; col3: string[];
}

export default function ThreeColumn({ title, sub, msg, col1_t, col2_t, col3_t, col1, col2, col3 }: Props) {
  return (
    <SlideFrame title={title} sub={sub} msg={msg}>
      <div className="three-col">
        <div className="three-col-col">
          <div className="three-col-head">{col1_t}</div>
          {col1.map((item, i) => <div key={i} className="three-col-item three-col-item--raw">{item}</div>)}
        </div>
        <div className="three-col-arrow">→</div>
        <div className="three-col-col">
          <div className="three-col-head">{col2_t}</div>
          {col2.map((item, i) => <div key={i} className="three-col-item three-col-item--mid">{item}</div>)}
        </div>
        <div className="three-col-arrow">→</div>
        <div className="three-col-col">
          <div className="three-col-head">{col3_t}</div>
          {col3.map((item, i) => <div key={i} className="three-col-item three-col-item--ready">{item}</div>)}
        </div>
      </div>
    </SlideFrame>
  );
}
